import { render, staticRenderFns } from "./CmgLeaderboard.vue?vue&type=template&id=15191b85&scoped=true&lang=pug"
import script from "./cmg-leaderboard.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboard.vue?vue&type=style&index=0&id=15191b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15191b85",
  null
  
)

export default component.exports